import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Radio from 'components/Input/Radio';

const BooleanRadio = ({ id, input, label, radioValue }) => {
    const checked = String(input.value) === radioValue;

    const labelClasses = classnames({
        'radio-square': true,
        'radio-square--binary': true,
        'radio-square--checked': checked,
    });

    return (
        <label htmlFor={id} className={labelClasses}>
            <Radio
                id={id}
                input={input}
                checked={checked}
                radioValue={radioValue}
                className="radio-square__radio"
            />
            {label}
        </label>
    );
};

BooleanRadio.displayName = 'BooleanRadio';

BooleanRadio.propTypes = {
    id: PropTypes.string,
    input: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        onBlur: PropTypes.func.isRequired,
    }).isRequired,
    label: PropTypes.string,
    radioValue: PropTypes.string,
};

BooleanRadio.defaultProps = {
    id: '',
    label: '',
};

/**
 * BooleanRadio Functional Component.
 */
export default BooleanRadio;
